module.exports = __webpack_public_path__ + "static/img/shengxiang-s.8a036cd.png";


//////////////////
// WEBPACK FOOTER
// ./static/compress-img/public/customer/shengxiang-s.png
// module id = yke5
// module chunks = 1